import ComingSoonPage from "../../components/ComingSoonPage";
import AppShell from '../../components/AppShell';

export default function SkillSage() {
  return (
    <AppShell>
      <div className="lg:col-span-8 space-y-6 text-center">
    <ComingSoonPage
      appName="Skill Sage AI"
      teaser="Unlock career growth with AI-personalized learning paths."
      imageSrc="/images/coming-soon/skillsage.png"
    />
    </div>
    </AppShell>
  );
}

